import type { Placement } from '@atlaskit/dropdown-menu/types';

export const MENU_WIDTH = {
  PRIMARY: 248,
  SUBMENU: 216,
  DRILLDOWN: 298,
  EXPANDED_SMALL: 534,
  EXPANDED_MEDIUM: 634,
  EXPANDED_LARGE: 684,
} as const;

export type MenuWidth = (typeof MENU_WIDTH)[keyof typeof MENU_WIDTH];

/**
 * Hover intent delay for submenu open on mouse-enter.
 * Prevents submenu flicker when the pointer sweeps quickly across menu items.
 */
export const HOVER_INTENT_DELAY_MS = 150;
export const SUBMENU_PLACEMENT: Placement = 'right-start';
export const SUBMENU_OFFSET: [number, number] = [-6, 4];

// Nested controls use these markers to claim Escape before the outer contextual menu.
// The active marker covers portal-rendered popups whose key events may start outside
// the marked trigger subtree.
export const CONTEXTUAL_MENU_ESCAPE_BOUNDARY_ATTR =
  'data-contextual-menu-escape-boundary';
export const CONTEXTUAL_MENU_ACTIVE_ESCAPE_BOUNDARY_ATTR =
  'data-contextual-menu-active-escape-boundary';
